import { yupResolver } from '@hookform/resolvers'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { ItemVoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomItemTextField'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  ListSubheader,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { AccountClient } from 'AccountClient'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  CommonStatus,
  useGetClassificationCodeQuery,
  useGetDepartmentListingByItemIdLazyQuery,
  useGetGlCompanyPolicyQuery,
  useGetTaxSchemeNewListingQuery,
  useGetTaxExemptionCalculationLazyQuery,
} from 'generated/graphql'
import { calculateTaxDetail } from 'helpers/Calculation/taxCalculationDetail'
import { filterTaxSchemeEffectiveDate } from 'helpers/Filter/filterTaxSchemeEffectiveDate'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as yup from 'yup'
import { calculateDocAmt } from '../../ARAPModule/Helper/AmountCalculation'
import { DefaultDepartmentHandlerService } from 'containers/GeneralLedgerModule/Hooks/DefaultDepartment/DefaultDepartmentService'
import { TaxExemptionCalculationData } from 'containers/APModule/components/ItemDialog'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'

interface ItemProps {
  BillItemID: string
  Amount: number
  DocAmt: number
  TaxSchemeID: string
  TaxAmt: any
  TaxAmtDetail: any
  TaxRate: number
  CostCentreID: string
  Remark: string
  einvoice_classification_code_id: string
  SalesOrderID: string
  ScheduledBillingItemID: string
  TaxExemptionReason: string
  TaxExemptionAmount: number
  TaxExemptionRate: number
}

const defaultVal: any = {
  BillItemID: null,
  Amount: 0,
  DocAmt: 0,
  TaxSchemeID: null,
  TaxAmt: 0,
  TaxRate: 0,
  CostCentreID: null,
  Remark: '',
  einvoice_classification_code_id: '',
  TaxExemptionReason: '',
  TaxExemptionAmount: 0,
  TaxExemptionRate: 0,
}

export const ARItemDialog = (props: any) => {
  const {
    taxEffectiveDate,
    CompanyID,
    openItemDialog,
    setOpenItemDialog,
    itemData,
    BillItemLoading,
    fetchBillItem,
    getBillItem,
    title,
    watch,
    menu,
    selectedTax,
    setSelectedTax,
    primaryItemKey,
  } = props

  // ================================== //
  // ============ USESTATE ============ //
  // ================================== //
  const [eInvoiceItemClassification, setEInvoiceItemClassification] = useState(
    null
  )
  const [classificationCodeID, setClassificationCodeID] = useState(
    menu?.obj?.einvoice_classification_code_id
      ? menu?.obj?.einvoice_classification_code_id
      : null
  )

  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [itemRecord, setItemRecord] = useState(false)
  const [itemVoiceRemark, setItemVoiceRemark] = useState('')
  const [exemptionVoiceReason, setExemptionVoiceReason] = useState('')
  const [exemptionRecord, setExemptionRecord] = useState(false)

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const [cost, setCost] = useState<number>(0)
  const [taxAmt, setTaxAmt] = useState(
    !!menu?.obj?.TaxAmt ? menu?.obj?.TaxAmt : 0
  )
  const [showExemptedFields, setShowExemptedFields] = useState<boolean>(
    !!menu?.obj?.TaxExemptionReason
  )
  // const docAmt = calculateDocAmt(cost, taxAmt)
  const ItemSchema = yup.object().shape({
    TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
    BillItemID: CommonYupValidation.requireField('Item is required'),
    CostCentreID: CommonYupValidation.requireField('Department is required'),
    Amount: yup
      .string()
      .required('Amount is required')
      .test('sumZero', 'Amount should not be zero', val => {
        return parseFloat(amtNumStr(val)) !== 0
      }),
    Remark: CommonYupValidation.requireField('Remark is required'),
    ...(!!showExemptedFields
      ? {
          TaxExemptionReason: CommonYupValidation.requireField(
            SystemMsgs.taxExemptionReason()
          ),
        }
      : null),
  })

  const [mountDefVal, setMountDefVal] = useState(!!menu?.obj)
  const [useDefaultDept, setUseDefaultDept] = useState(false)

  // ================================= //
  // ============ USEFORM ============ //
  // ================================= //
  const {
    handleSubmit: handleItemSubmit,
    register: itemRegister,
    setValue: setValueItem,
    watch: itemWatch,
    errors: itemErrors,
    control: itemControl,
    clearErrors: clearErrorsItem,
    reset: itemReset,
  } = useForm<ItemProps>({
    defaultValues: {
      BillItemID: !!menu?.obj?.BillItemID ? menu?.obj?.BillItemID : '',
      DocAmt: !!menu?.obj?.DocAmt ? menu?.obj?.DocAmt : 0,
      TaxSchemeID: !!menu?.obj?.TaxSchemeID ? menu?.obj?.TaxSchemeID : '',
      TaxAmt: !!menu?.obj?.TaxAmt ? menu?.obj?.TaxAmt : 0,
      TaxRate: 0,
      Remark: !!menu?.obj?.Remark ? menu?.obj?.Remark : '',
      TaxAmtDetail: [],
      einvoice_classification_code_id: !!menu?.obj
        ?.einvoice_classification_code_id
        ? menu?.obj?.einvoice_classification_code_id
        : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(ItemSchema),
  })

  // ================================= //
  // ============ QUERIES ============ //
  // ================================= //
  const { loading: GLCompanyLoading } = useGetGlCompanyPolicyQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
    onCompleted: ({ getGLCompanyPolicy }) => {
      setUseDefaultDept(getGLCompanyPolicy[0]?.DefaultDepartmentBalanceSheetCOA)
    },
  })

  const {
    loading: TaxSchemeOutputLoading,
    data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
  } = useGetTaxSchemeNewListingQuery({
    fetchPolicy: 'network-only',
    client: AccountClient,
    variables: { CommonStatus: CommonStatus.Active, TaxClass: 'OUTPUT' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      if (menu?.obj?.TaxSchemeID) {
        let filteredTaxScheme = filterTaxSchemeEffectiveDate(
          taxEffectiveDate,
          getTaxSchemeListing
        )

        let selectTax = filteredTaxScheme.find(
          x => x?.id === menu?.obj?.TaxSchemeID
        )
        setSelectedTax(selectTax)
        setValueItem('TaxSchemeID', selectTax?.id)
        clearErrorsItem('TaxSchemeID')

        initializeTaxDetailsInEditMode(selectTax)

        let recalculateCost =
          selectTax?.isExclusive === true
            ? menu?.obj?.DocAmt - menu?.obj?.TaxAmt
            : menu?.obj?.DocAmt

        setCost(recalculateCost)
        setValueItem('Amount', recalculateCost)
      }

      // Fetch department listing
      if (menu?.obj?.BillItemID && mountDefVal === true) {
        fetchDepartmentListingByItemID({
          variables: { CompanyID, BillItemID: menu?.obj?.BillItemID },
        })
      }
    },
  })

  const {
    loading: ClassificationCodeLoading,
    data: { getClassificationCode } = { getClassificationCode: [] },
  } = useGetClassificationCodeQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      if (menu?.obj?.einvoice_classification_code_id) {
        setValueItem(
          'einvoice_classification_code_id',
          menu?.obj?.einvoice_classification_code_id
        )
      }
    },
  })

  /* -------------------------------------------- */
  /*                   DEF DEPT                   */
  /* -------------------------------------------- */

  const [
    fetchDepartmentListingByItemID,
    {
      loading: HandlerLoading,
      called: HandlerCalled,
      data: { getDepartmentListingByItemID } = {
        getDepartmentListingByItemID: [],
      },
    },
  ] = useGetDepartmentListingByItemIdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getDepartmentListingByItemID }) => {
      DefaultDepartmentHandlerService.InitializeDepartmentValueInEditMode({
        DepartmentListingArray: getDepartmentListingByItemID,
        DefaultDepartmentPolicy: useDefaultDept, // nullable; used for GL Department Policy checking
        EditData: menu?.obj,
        SetValue: setValueItem,
        Register: itemRegister,
        MountDefVal: mountDefVal, // to avoid overriding costcentreid on another api call
      })
    },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)
    },
  })

  const isDefaultChecking: boolean =
    HandlerCalled === true
      ? !!(
          getDepartmentListingByItemID?.length === 1 &&
          !!getDepartmentListingByItemID[0]?.IsDefault
        )
      : false

  const disableDeptController: boolean = !!(
    useDefaultDept === true && isDefaultChecking === true
  )
  //============================================================================

  /* -------------------------------------------- */
  /*                 EXEMPTED TAX                 */
  /* -------------------------------------------- */
  const [awaitCalc, setAwaitCalc] = useState<boolean>(false)
  const [debounceTimer, setDebounceTimer] = useState(null)
  const [taxExemptionData, setTaxExemptionData] = useState<
    TaxExemptionCalculationData
  >({
    TaxExemptionRate: menu?.obj?.TaxExemptionRate ?? null,
    TaxExemptionAmount: menu?.obj?.TaxExemptionAmount ?? null,
  })

  const [
    fetchExemptedTaxCalc,
    { loading: ExemptedTaxCalcLoading },
  ] = useGetTaxExemptionCalculationLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)

      setAwaitCalc(false)
    },
    onCompleted: ({ getTaxExemptionCalculation }) => {
      setTaxExemptionData({
        TaxExemptionRate: getTaxExemptionCalculation?.TaxExemptionRate,
        TaxExemptionAmount: getTaxExemptionCalculation?.TaxExemptionAmount,
      })

      setAwaitCalc(false)
    },
  })

  // Debounce method for API based calculation
  const debounceExemptCalc = (
    currTaxSchemeId: string,
    effDate: Date,
    baseAmt: number
  ) => {
    setAwaitCalc(true)
    setTaxExemptionData({ TaxExemptionAmount: null, TaxExemptionRate: null })
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    const newTimer = setTimeout(() => {
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: currTaxSchemeId,
          EffectiveDate: effDate,
          BaseAmount: baseAmt,
        },
      })
    }, 1500)

    setDebounceTimer(newTimer)
  }

  //============================================================================

  const taxSchemeOutput = filterTaxSchemeEffectiveDate(
    taxEffectiveDate,
    getTaxSchemeListing
  )

  const taxSchemeName = taxSchemeOutput?.filter(
    x => x?.id === selectedTax?.id
  )[0]?.name

  const itemName =
    itemWatch('BillItemID') !== undefined
      ? getBillItem.find(x => x?.BillItemID === itemWatch('BillItemID'))?.Name
      : getBillItem.find(x => x?.BillItemID === menu?.obj?.BillItemID)?.Name

  const classificationCode = !!classificationCodeID
    ? getClassificationCode?.find(x => x?.id === classificationCodeID)
        ?.classificationCode
    : getClassificationCode?.find(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )?.classificationCode

  const classificationDescription = !!classificationCodeID
    ? getClassificationCode?.find(x => x?.id === classificationCodeID)
        ?.description
    : getClassificationCode?.find(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )?.description

  const onSubmit = (data, docAmt, index, isSaveNew) => {
    // definite checking for tax scheme control
    const taxIsExclusive = getTaxSchemeListing?.find(
      x => x?.id === data?.TaxSchemeID
    )?.isExclusive

    const formattedTaxDetails = result.taxDetails.map((tax, idx) => {
      return {
        seqNo: tax?.SeqNo,
        taxAmt: itemWatch(`TaxAmtDetail[${idx}]`) ?? tax.TaxAmount,
        taxRate: tax.TaxRate * 100,
        taxCode: tax.taxCode,
        taxId: tax.taxId,
        taxSchemeDetailId: tax.taxSchemeDetailId,
        taxSchemeId: tax.taxSchemeId,
      }
    })

    if (!menu?.obj) {
      itemData.push({
        Sequence: itemData?.length + 1,
        BillItemID: data?.BillItemID,
        CostCentreID: data?.CostCentreID,
        Amount:
          taxIsExclusive === true
            ? parseFloat(data?.Amount.replace(/,/g, ''))
            : docAmt - data?.TaxAmt,
        TaxSchemeID: data?.TaxSchemeID,
        TaxRate: 0,
        TaxCode: taxSchemeName,
        BillItemName: itemName,
        CostCentreName: getDepartmentListingByItemID?.find(
          x => x?.CostCentreID === itemWatch('CostCentreID')
        )?.Code,
        TaxAmt: data?.TaxAmt,
        DocAmt: docAmt,
        Remark: data?.Remark,
        ItemTaxInfo: formattedTaxDetails,
        einvoice_classification_code_id:
          classificationCodeID !== null ? classificationCodeID : null,
        ClassificationCode:
          classificationCodeID !== null ? classificationCode : null,
        ClassificationDescription:
          classificationCodeID !== null ? classificationDescription : null,
        TaxExemptionReason:
          showExemptedFields && data?.TaxExemptionReason
            ? data?.TaxExemptionReason
            : null,
        TaxExemptionAmount:
          showExemptedFields && taxExemptionData?.TaxExemptionAmount
            ? taxExemptionData?.TaxExemptionAmount
            : null,
        TaxExemptionRate:
          showExemptedFields && taxExemptionData?.TaxExemptionRate
            ? taxExemptionData?.TaxExemptionRate
            : null,
      })
    } else {
      itemData[index] = {
        Sequence: itemData?.Sequence ?? index + 1,
        [`${primaryItemKey}`]: itemData[index]?.[`${primaryItemKey}`],
        BillItemID: data?.BillItemID,
        CostCentreID: data?.CostCentreID,
        Amount:
          taxIsExclusive === true
            ? parseFloat(data?.Amount.replace(/,/g, ''))
            : docAmt - data?.TaxAmt,
        BillItemName: itemName,
        CostCentreName: getDepartmentListingByItemID?.find(
          x => x?.CostCentreID === itemWatch('CostCentreID')
        )?.Code,
        TaxRate: 0,
        TaxCode: taxSchemeName,
        TaxSchemeID: data?.TaxSchemeID,
        SalesOrderID: menu?.obj?.SalesOrderID ?? null,
        ScheduledBillingItemID: menu?.obj?.ScheduledBillingItemID ?? null,
        TaxAmt: data?.TaxAmt,
        DocAmt: docAmt,
        Remark: data?.Remark,
        ItemTaxInfo: formattedTaxDetails,
        einvoice_classification_code_id:
          classificationCodeID !== null ? classificationCodeID : null,
        ClassificationCode:
          classificationCodeID !== null ? classificationCode : null,
        ClassificationDescription:
          classificationCodeID !== null ? classificationDescription : null,
        TaxExemptionReason:
          showExemptedFields && data?.TaxExemptionReason
            ? data?.TaxExemptionReason
            : null,
        TaxExemptionAmount:
          showExemptedFields && taxExemptionData?.TaxExemptionAmount
            ? taxExemptionData?.TaxExemptionAmount
            : null,
        TaxExemptionRate:
          showExemptedFields && taxExemptionData?.TaxExemptionRate
            ? taxExemptionData?.TaxExemptionRate
            : null,
      }
    }

    if (!isSaveNew) {
      setOpenItemDialog(false)
    } else {
      fetchBillItem()
      itemReset(defaultVal)
      setOpenItemDialog(true)
    }

    // reset tax calculation
    result = {
      taxDetails: [],
      ExcludeTaxAmount: 0,
      IncludeTaxAmount: 0,
      TaxAmount: 0,
    }
    setSelectedTax(null)
    setTaxAmt(0)
  }

  // ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ - TAX CALCULATION - ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ //
  const prepareTaxCalculationData = (selectedTax: any) => {
    if (!selectedTax?.taxSchemeDetailList[0]?.taxSchemeDetailItemList?.length) {
      return []
    }

    const taxSchemeDetail = selectedTax?.taxSchemeDetailList[0]

    return taxSchemeDetail.taxSchemeDetailItemList.map(item => ({
      taxId: item.taxId,
      taxSchemeId: taxSchemeDetail.taxSchemeId,
      taxSchemeDetailId: taxSchemeDetail.id,
      seqNo: item.seqNo,
      taxOnSeq: item.taxOnSeq || [],
      computeMethod:
        item.computeMethod === 'TAX_ON_GROSS'
          ? 'Tax_On_Gross'
          : 'Tax_On_Taxed_Price',
      taxRate: item.taxRate,
      taxCode: item.taxInfo?.code,
    }))
  }

  const calculateTaxFromState = (selectedTax: any, amount: number) => {
    const taxData = prepareTaxCalculationData(selectedTax)

    const isExclusive = Boolean(selectedTax?.isExclusive)

    return calculateTaxDetail(taxData, amount, isExclusive)
  }
  let result = calculateTaxFromState(selectedTax, cost)

  const initializeTaxDetailsInEditMode = selectTax => {
    if (menu?.obj?.TaxAmtDetails && Array.isArray(menu?.obj?.TaxAmtDetails)) {
      menu.obj.TaxAmtDetails.forEach((taxDetail, index) => {
        itemRegister(`TaxAmtDetail[${index}]`)
        setValueItem(`TaxAmtDetail[${index}]`, taxDetail.taxAmount)
      })
      setValueItem('taxDetailsCount', menu.obj.TaxAmtDetails.length)
    } else if (selectTax) {
      const currentAmount = Number(
        selectTax?.isExclusive === true ? menu?.obj?.Amount : menu?.obj?.DocAmt
      )
      const taxResult = calculateTaxFromState(selectTax, currentAmount)
      if (taxResult?.taxDetails) {
        updateTaxDetailsInForm(taxResult.taxDetails, taxResult.TaxAmount)
      }
    }
  }

  const updateTaxDetailsInForm = (taxDetails, taxAmount) => {
    if (!taxDetails || taxDetails.length === 0) return
    const prevTaxDetailsCount = itemWatch('taxDetailsCount') || 0
    taxDetails.forEach((tax, index) => {
      itemRegister(`TaxAmtDetail[${index}]`)
      setValueItem(`TaxAmtDetail[${index}]`, tax.TaxAmount)
    })
    setValueItem('taxDetailsCount', taxDetails.length)
    if (prevTaxDetailsCount > taxDetails.length) {
      for (let i = taxDetails.length; i < prevTaxDetailsCount; i++) {
        setValueItem(`TaxAmtDetail[${i}]`, null)
      }
    }
    setValueItem('TaxAmt', taxAmount)
    setTaxAmt(taxAmount)
  }

  const docAmt = selectedTax?.isExclusive
    ? calculateDocAmt(cost, taxAmt)
    : Number(parseFloat(String(itemWatch('Amount')).replace(/,/g, '')) || 0)

  const handleAmtChange = event => {
    setCost(event.value)
    if (selectedTax) {
      prepareTaxCalculationData(selectedTax)
      const taxResult = calculateTaxFromState(selectedTax, event.value)
      setTaxAmt(taxResult?.TaxAmount)
      updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)
      setValueItem(
        'TaxAmt',
        calculateTaxFromState(selectedTax, event.value)?.TaxAmount
      )

      if (selectedTax?.isExemptedTaxScheme === true) {
        debounceExemptCalc(
          selectedTax?.id,
          new Date(taxEffectiveDate),
          Number(event.value)
        )
      }
    }
  }

  const handleTaxChange = event => {
    const currentTax = taxSchemeOutput.find(x => x?.id === event?.target?.value)
    const taxResult = calculateTaxFromState(currentTax, cost)
    updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)
    setSelectedTax(taxSchemeOutput.find(x => x?.id === event?.target?.value))
    setTaxAmt(taxResult?.TaxAmount)

    // Exempted Tax portion
    setShowExemptedFields(!!currentTax?.isExemptedTaxScheme)

    if (currentTax?.isExemptedTaxScheme === true) {
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: event?.target?.value,
          EffectiveDate: new Date(taxEffectiveDate),
          BaseAmount: Number(cost),
        },
      })
    }
  }

  const handleTaxAmtChange = event => {
    setTaxAmt(event.value)
  }

  const checkClassificationCode = billItem => {
    if (
      billItem?.einvoice_classification_code_id !== null &&
      billItem?.einvoice_classification_code_id !== undefined &&
      billItem?.einvoice_classification_code_id !== ''
    )
      return true
    else return false
  }

  /* -------------------------------------------- */
  /*                  USEEFFECT                   */
  /* -------------------------------------------- */
  useEffect(() => {
    if (!isNaN(taxAmt)) {
      setValueItem('TaxAmt', taxAmt)
      clearErrorsItem('TaxAmt')
    }
  }, [taxAmt])

  return (
    <>
      {HandlerLoading && <Loading />}
      {BillItemLoading && <Loading />}
      {GLCompanyLoading && <Loading />}
      {ExemptedTaxCalcLoading && <Loading />}
      {TaxSchemeOutputLoading && <Loading />}
      {ClassificationCodeLoading && <Loading />}
      <CommonDialog
        fullWidth={true}
        open={openItemDialog}
        onClose={() => {
          setOpenItemDialog(false)
        }}
        sections={{
          header: { title, rightText: !!menu?.obj ? 'Edit' : 'New' },
          body: () => (
            <>
              <div className="content-container" style={{ marginTop: '-20px' }}>
                {!BillItemLoading && (
                  <Controller
                    render={({ onChange, value }) => {
                      const defVal = getBillItem?.filter(
                        x => x?.BillItemID === menu?.obj?.BillItemID
                      )[0]

                      return (
                        <Autocomplete
                          options={
                            watch('is_einvoice') === true
                              ? getBillItem.filter(
                                  item => item.einv_integrated === true
                                )
                              : getBillItem?.sort((a, b) => {
                                  return a.Name.localeCompare(b.Name)
                                }) || []
                          }
                          getOptionLabel={option =>
                            `${option?.Name} | ${option?.Description}`
                          }
                          fullWidth
                          onChange={(value, newValue: any) => {
                            onChange(newValue?.BillItemID)
                            setValueItem('BillItemID', newValue?.BillItemID)

                            // Tax Bill Item handling
                            let defTax = getBillItem?.filter(
                              x => x?.BillItemID === newValue?.BillItemID
                            )[0]?.TaxSchemeID
                            let selectedTax = taxSchemeOutput.find(
                              x => x?.id === defTax
                            )
                            setValueItem('TaxSchemeID', selectedTax?.id)
                            setSelectedTax(selectedTax)
                            const taxResult = calculateTaxFromState(
                              selectedTax,
                              cost
                            )
                            setTaxAmt(taxResult?.TaxAmount)
                            setValueItem('TaxAmt', taxResult?.TaxAmount)
                            updateTaxDetailsInForm(
                              taxResult?.taxDetails,
                              taxResult?.TaxAmount
                            )
                            setValueItem('Remark', `${newValue?.Name}`)

                            // when changing item, fetch direct lazy query
                            if (selectedTax?.isExemptedTaxScheme === true) {
                              setShowExemptedFields(true)
                              fetchExemptedTaxCalc({
                                variables: {
                                  TaxSchemeID: defTax,
                                  EffectiveDate: new Date(taxEffectiveDate),
                                  BaseAmount: Number(cost),
                                },
                              })
                            }

                            // Cost Centre handling
                            setValueItem('CostCentreID', null)
                            setMountDefVal(false)
                            fetchDepartmentListingByItemID({
                              variables: {
                                CompanyID,
                                BillItemID: newValue?.BillItemID,
                              },
                            })
                            if (!!checkClassificationCode(newValue)) {
                              setClassificationCodeID(
                                !!newValue?.einvoice_classification_code_id
                                  ? newValue?.einvoice_classification_code_id
                                  : null
                              )
                              if (
                                newValue?.einvoice_classification_code_id !==
                                null
                              ) {
                                setEInvoiceItemClassification(
                                  getClassificationCode?.filter(
                                    x =>
                                      x?.id ===
                                      newValue?.einvoice_classification_code_id
                                  )[0]?.classificationCode +
                                    ` (` +
                                    getClassificationCode?.filter(
                                      x =>
                                        x?.id ===
                                        newValue?.einvoice_classification_code_id
                                    )[0]?.description +
                                    `)`
                                )
                                setValueItem(
                                  'einvoice_classification_code_id',
                                  classificationCodeID ??
                                    newValue?.einvoice_classification_code_id
                                )
                              }
                            }
                          }}
                          renderOption={(props, option) => {
                            return (
                              <div>
                                <div>
                                  <span className="xsTitle">{props?.Name}</span>
                                </div>
                                <div className="desc">{props?.Description}</div>
                              </div>
                            )
                          }}
                          defaultValue={defVal}
                          renderInput={(params: any) => {
                            return (
                              <div>
                                <TextField
                                  {...params}
                                  required
                                  label="Item"
                                  variant="standard"
                                  fullWidth
                                  name="BillItemID"
                                  helperText={itemErrors?.BillItemID?.message}
                                  error={itemErrors?.BillItemID ? true : false}
                                />
                              </div>
                            )
                          }}
                        />
                      )
                    }}
                    name="BillItemID"
                    autoComplete="off"
                    control={itemControl}
                    multiline={true}
                    fullWidth
                    margin="dense"
                    ref={itemRegister}
                    required
                    defaultValue={menu?.obj?.BillItemID}
                    helperText={itemErrors?.BillItemID?.message}
                    error={itemErrors?.BillItemID ? true : false}
                  />
                )}
                {/* Classification e-Invoice */}
                {watch('is_einvoice') === true && !ClassificationCodeLoading && (
                  <Controller
                    render={({ value, onChange }) => {
                      return (
                        <TextField
                          label="Classification"
                          value={
                            menu?.obj?.einvoice_classification_code_id
                              ? `${getClassificationCode?.filter(
                                  x =>
                                    x?.id ===
                                    menu?.obj?.einvoice_classification_code_id
                                )[0]?.classificationCode +
                                  ` (` +
                                  getClassificationCode?.filter(
                                    x =>
                                      x?.id ===
                                      menu?.obj?.einvoice_classification_code_id
                                  )[0]?.description +
                                  `)`}`
                              : eInvoiceItemClassification ?? ''
                          }
                          InputProps={{ readOnly: true }}
                          fullWidth
                          disabled
                          name="einvoice_classification_code_id"
                        />
                      )
                    }}
                    margin="dense"
                    name="einvoice_classification_code_id"
                    ref={itemRegister}
                    control={itemControl}
                    defaultValue={
                      menu?.obj?.einvoice_classification_code_id
                        ? menu?.obj?.einvoice_classification_code_id
                        : null
                    }
                    disabled
                  />
                )}

                <Controller
                  render={({ value, onChange }) => {
                    const defVal = !!itemWatch('CostCentreID')
                      ? getDepartmentListingByItemID?.find(
                          x => x?.CostCentreID === itemWatch('CostCentreID')
                        )
                      : null
                    return (
                      <Autocomplete
                        options={getDepartmentListingByItemID || []}
                        getOptionLabel={option =>
                          option
                            ? `${option?.MasterCode} | ${option?.Name}`
                            : ''
                        }
                        fullWidth
                        onChange={(value, newValue: any) => {
                          onChange(newValue?.CostCentreID)
                        }}
                        disableClearable={disableDeptController}
                        disabled={disableDeptController}
                        renderOption={(props, option) => {
                          return (
                            <div>
                              <div>
                                <span className="xsTitle">
                                  {props?.MasterCode}
                                </span>
                              </div>
                              <div className="desc">{props?.Name}</div>
                            </div>
                          )
                        }}
                        value={
                          disableDeptController === true
                            ? getDepartmentListingByItemID[0]
                            : defVal
                        }
                        renderInput={(params: any) => {
                          return (
                            <div>
                              <TextField
                                {...params}
                                helperText={
                                  itemErrors?.CostCentreID
                                    ? 'Department is required'
                                    : ''
                                }
                                error={itemErrors?.CostCentreID ? true : false}
                                label="Department"
                                style={{ width: '100%' }}
                                margin="dense"
                                disabled={disableDeptController}
                                required
                              />
                            </div>
                          )
                        }}
                      />
                    )
                  }}
                  label="Department"
                  name="CostCentreID"
                  autoComplete="off"
                  control={itemControl}
                  multiline={true}
                  fullWidth
                  margin="dense"
                  ref={itemRegister}
                  helperText={itemErrors?.CostCentreID?.message}
                  error={itemErrors?.CostCentreID ? true : false}
                  disabled={disableDeptController}
                  required
                />
                <Controller
                  as={<NumberFormat allowNegative={false} />}
                  thousandSeparator
                  customInput={TextField}
                  id="standard-basic"
                  name="Amount"
                  label="Amount"
                  value={cost}
                  autoComplete="off"
                  control={itemControl}
                  onValueChange={e => {
                    handleAmtChange(e)
                  }}
                  decimalScale={2}
                  fixedDecimalScale
                  margin="dense"
                  required
                  fullWidth
                  helperText={itemErrors?.Amount?.message}
                  error={itemErrors?.Amount ? true : false}
                  ref={itemRegister()}
                  defaultValue={cost || ''}
                  disabled={menu?.obj?.SalesOrderID}
                />
                <Grid item xs={12}>
                  <Controller
                    as={
                      <TextField
                        margin="normal"
                        label="Tax Scheme"
                        required
                        SelectProps={{
                          renderValue: () =>
                            `${selectedTax?.name} | ${
                              selectedTax?.description
                            } ${selectedTax?.isExclusive ? `(E)` : `(I)`}`,
                          onChange: event => {
                            handleTaxChange(event)
                            setValueItem(
                              'TaxSchemeID',
                              event?.target?.value.toString()
                            )
                            clearErrorsItem('TaxSchemeID')
                          },
                        }}
                        select
                        helperText={itemErrors?.TaxSchemeID?.message}
                        error={itemErrors?.TaxSchemeID ? true : false}
                        fullWidth
                      >
                        <ListSubheader>Output</ListSubheader>
                        {taxSchemeOutput?.map((taxScheme, index) => (
                          <MenuItem
                            id="tax-select"
                            key={index}
                            value={taxScheme?.id}
                          >
                            {
                              <div className="content-wrap full">
                                <div>
                                  <span className="xsTitle">
                                    {taxScheme?.name}
                                  </span>
                                </div>
                                <div className="desc">
                                  {taxScheme?.description}{' '}
                                  {taxScheme?.isExclusive ? `(E)` : `(I)`}
                                </div>
                              </div>
                            }
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                    select
                    name="TaxSchemeID"
                    autoComplete="off"
                    control={itemControl}
                    defaultValue={menu?.obj?.TaxSchemeID || ''}
                    ref={itemRegister}
                  />
                </Grid>
                {result.taxDetails.length > 0 && (
                  <Grid item xs={12}>
                    <Paper
                      elevation={1}
                      style={{
                        padding: '1px 7px',
                        borderRadius: '2px',
                        backgroundColor: '#fff9f2',
                      }}
                    >
                      {result.taxDetails.map((tax, index) => (
                        <Grid
                          container
                          key={index}
                          spacing={1}
                          alignItems="center"
                        >
                          <Grid item xs={4}>
                            <Typography
                              variant="body2"
                              style={{
                                fontSize: '0.63rem',
                                fontWeight: 500,
                                lineHeight: '24px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {tax?.taxCode || `Tax ${index + 1}`}
                            </Typography>
                          </Grid>

                          <Grid item xs={3}>
                            <Typography
                              variant="body2"
                              style={{
                                fontSize: '0.63rem',
                                fontWeight: 500,
                                lineHeight: '24px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {typeof tax?.TaxRate === 'number'
                                ? `${(tax.TaxRate * 100).toFixed(2)}%`
                                : `N/A`}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Controller
                              name={`TaxAmtDetail[${index}]`}
                              control={itemControl}
                              defaultValue={tax.TaxAmount}
                              render={({ onChange, value }) => (
                                <NumberFormat
                                  customInput={TextField}
                                  fullWidth
                                  className="disabled-input"
                                  thousandSeparator
                                  decimalScale={2}
                                  fixedDecimalScale
                                  style={{
                                    marginTop: '10px',
                                    fontSize: '0.63rem',
                                  }}
                                  allowNegative={false}
                                  size="small"
                                  value={
                                    itemWatch(`TaxAmtDetail[${index}]`) ??
                                    tax.TaxAmount
                                  }
                                  InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                    style: {
                                      fontSize: '0.63rem',
                                      height: '23px',
                                      padding: '0 4px',
                                    },
                                  }}
                                  InputLabelProps={{
                                    style: { display: 'none' },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Paper>
                  </Grid>
                )}
                <Grid item xs={12} style={{ height: '16px' }} />
                <Controller
                  as={<NumberFormat allowNegative={false} />}
                  thousandSeparator
                  customInput={TextField}
                  ref={itemRegister()}
                  control={itemControl}
                  margin="dense"
                  name="TaxAmt"
                  label="Tax Amount"
                  onValueChange={e => {
                    handleTaxAmtChange(e)
                    setTaxAmt(e?.floatValue)
                  }}
                  value={taxAmt}
                  defaultValue={menu?.obj?.TaxAmt ?? taxAmt ?? 0}
                  decimalScale={2}
                  fixedDecimalScale
                  className="left"
                  InputProps={{ disableUnderline: true, readOnly: true }}
                />
                <Controller
                  render={({ value, onChange }) => {
                    value = { docAmt }
                    return (
                      <TextField
                        margin="dense"
                        label="Doc Amount"
                        value={
                          selectedTax?.isExclusive
                            ? amtStr(calculateDocAmt(cost, taxAmt))
                            : amtStr(
                                parseFloat(
                                  String(itemWatch('Amount')).replace(/,/g, '')
                                )
                              )
                        }
                        InputProps={{ readOnly: true, disableUnderline: true }}
                        className="right"
                        disabled
                      />
                    )
                  }}
                  disabled
                  margin="dense"
                  defaultValue={(docAmt || 0) ?? (menu?.obj?.DocAmt || 0)}
                  name="DocAmt"
                  ref={itemRegister()}
                  control={itemControl}
                />
                <ItemVoiceTextField
                  mounted={true}
                  label="Remark"
                  name="Remark"
                  value={itemVoiceRemark}
                  setValue={setValueItem}
                  record={itemRecord}
                  setRecord={setItemRecord}
                  control={itemControl}
                  controllerProps={{
                    error: itemErrors?.Remark ? true : false,
                    defaultValue: menu?.obj?.Remark,
                    helperText: itemErrors?.Remark?.message,
                    ref: itemRegister,
                    autoComplete: 'off',
                  }}
                  required
                />
                {showExemptedFields && (
                  <>
                    <ItemVoiceTextField
                      mounted={true}
                      required
                      label="Tax Exemption Reason"
                      name="TaxExemptionReason"
                      value={exemptionVoiceReason}
                      setValue={setValueItem}
                      record={exemptionRecord}
                      setRecord={setExemptionRecord}
                      control={itemControl}
                      controllerProps={{
                        error: itemErrors?.TaxExemptionReason ? true : false,
                        defaultValue: menu?.obj?.TaxExemptionReason,
                        helperText: itemErrors?.TaxExemptionReason?.message,
                        ref: itemRegister,
                        autoComplete: 'off',
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="Exemptible Tax Amount"
                      value={amtStr(taxExemptionData?.TaxExemptionAmount)}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <>
                            {awaitCalc ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                          </>
                        ),
                      }}
                      className="left"
                      disabled
                    />
                    {/* <TextField
                      margin="dense"
                      label="Exemptible Tax Rate"
                      value={`${amtStr(taxExemptionData?.TaxExemptionRate)}%`}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <>
                            {awaitCalc ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                          </>
                        ),
                      }}
                      className="right"
                      disabled
                    /> */}
                  </>
                )}
              </div>
            </>
          ),
          footer: {
            actions: !menu?.obj
              ? [
                  {
                    displayText: 'Close',
                    props: {
                      onClick: () => {
                        setOpenItemDialog(false)
                      },
                      variant: 'contained',
                      color: 'primary',
                    },
                  },
                  {
                    displayText: 'Confirm & New',
                    props: {
                      onClick: () => {
                        handleItemSubmit(data =>
                          onSubmit(data, docAmt, menu?.index, true)
                        )()
                        setMountDefVal(false)
                      },
                      variant: 'contained',
                      color: 'primary',
                      disabled: !!awaitCalc,
                    },
                  },
                  {
                    displayText: 'Confirm',
                    props: {
                      onClick: () => {
                        handleItemSubmit(data =>
                          onSubmit(data, docAmt, menu?.index, false)
                        )()
                      },
                      variant: 'contained',
                      color: 'primary',
                      disabled: !!awaitCalc,
                    },
                  },
                ]
              : [
                  {
                    displayText: 'Close',
                    props: {
                      onClick: () => setOpenItemDialog(false),
                      variant: 'contained',
                      color: 'primary',
                    },
                  },
                  {
                    displayText: 'Confirm',
                    props: {
                      onClick: () => {
                        handleItemSubmit(data =>
                          onSubmit(data, docAmt, menu?.index, false)
                        )()
                      },
                      variant: 'contained',
                      color: 'primary',
                      disabled: !!awaitCalc,
                    },
                  },
                ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
